import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column'
  },

  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '0.0625rem solid #F1F1F1',
    minHeight: 48,
    padding: '0 16px 0 0',
    cursor: 'pointer',

    '& svg': {
      flexShrink: 0
    }
  },

  title: {
    width: '100%',
    cursor: 'inherit',
    fontSize: theme.size.base
  },

  drag: {
    marginRight: '1rem',
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },

  drop: {
    position: 'absolute',
    boxSizing: 'border-box',
    width: '100%',
    height: '6px',
    backgroundColor: 'transparent'
  },

  dropTop: {
    top: '0',
    borderRadius: '100rem 100rem 0 0'
  },

  dropBottom: {
    bottom: '0'
  },

  dropBottomRound: {
    borderRadius: '0 0 100rem 100rem'
  },

  dropOver: {
    backgroundColor: theme.palette.primary.main
  }
}))

export default useStyles
